import {
  Radio,
  ListChecks,
  ClipboardList,
  BarChart3,
  FileDown,
  User,
  School,
} from 'lucide-react';

interface Section {
  icon: React.ElementType;
  title: string;
  description: string;
  steps?: string[];
}

const SECTIONS: Section[] = [
  {
    icon: Radio,
    title: 'Na żywo test teor.',
    description:
      'Widok na bieżąco — pokazuje, ile osób aktualnie rozwiązuje test teoretyczny, ile już skończyło, a ile jeszcze nie zaczęło. Strona odświeża się automatycznie co kilka sekund. Nie wymaga żadnych działań z Państwa strony.',
  },
  {
    icon: ListChecks,
    title: 'Status testu E2 teor.',
    description:
      'Lista wszystkich uczestników Etapu 2 z informacją o statusie ich testu teoretycznego: nierozpoczęty, w trakcie lub zakończony. Można tu sprawdzić, czy dany uczestnik zalogował się i przystąpił do testu.',
  },
  {
    icon: ClipboardList,
    title: 'Wyniki praktyczne E2',
    description:
      'Tutaj wprowadzają Państwo punkty z egzaminu praktycznego dla każdego uczestnika Etapu 2.',
    steps: [
      'Znajdź uczestnika na liście (możesz skorzystać z wyszukiwarki).',
      'Wpisz liczbę uzyskanych punktów w polu „Punkty".',
      'Wybierz tryb czasu: minutowy (wpisz łączny czas w minutach) lub zakresowy (wpisz godzinę startu i końca).',
      'Kliknij „Zapisz" przy danym uczestniku.',
    ],
  },
  {
    icon: BarChart3,
    title: 'Tabela wyników',
    description:
      'Aktualny ranking Etapu 2 — sortowany według łącznego wyniku (test teoretyczny + egzamin praktyczny). Przy równej liczbie punktów o kolejności decyduje łączny czas. Można tu pobrać wyniki w formie pliku CSV.',
  },
  {
    icon: FileDown,
    title: 'Raporty CSV',
    description:
      'Zbiór plików do pobrania z wynikami turnieju. Dostępne raporty dla Etapu 2 to: wyniki łączne (ranking końcowy), wyniki testu teoretycznego, wyniki egzaminu praktycznego oraz lista uczestników.',
  },
  {
    icon: User,
    title: 'Uczestnicy',
    description:
      'Pełna lista uczestników zakwalifikowanych do Etapu 2 wraz z danymi kontaktowymi i nazwą szkoły. Widok tylko do podglądu — edycja nie jest możliwa z poziomu panelu organizatora.',
  },
  {
    icon: School,
    title: 'Szkoły',
    description:
      'Lista szkół biorących udział w turnieju. Widok tylko do podglądu — można sprawdzić dane kontaktowe do koordynatorów szkolnych.',
  },
];

export const OrganizerHomePage = () => (
  <div className="space-y-6 max-w-3xl">
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Witamy w Panelu Organizatora</h2>
      <p className="mt-1 text-sm text-gray-500">
        Poniżej znajdą Państwo krótki opis każdej sekcji panelu. W razie pytań prosimy o kontakt.
      </p>
    </div>

    <div className="divide-y divide-gray-100 rounded-xl border border-gray-200 bg-white">
      {SECTIONS.map(({ icon: Icon, title, description, steps }) => (
        <div key={title} className="flex gap-4 px-5 py-4">
          <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-50">
            <Icon className="h-4 w-4 text-primary-600" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">{title}</p>
            <p className="mt-0.5 text-sm leading-relaxed text-gray-500">{description}</p>
            {steps && (
              <ol className="mt-2 space-y-0.5">
                {steps.map((step, i) => (
                  <li key={i} className="flex gap-2 text-xs text-gray-500">
                    <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[10px] font-bold text-primary-700">
                      {i + 1}
                    </span>
                    {step}
                  </li>
                ))}
              </ol>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);
